import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { GET_RULES_DETAILS, GET_RULES_DETAILS_SUCCESS, GET_RULES_DETAILS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getRulesDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { ruleId } = payload?.urlParams || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaign/rule-by-id/${ruleId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_RULES_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RULES_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RULES_DETAILS_ERROR, payload: error });
  }
}

export function* watchgetRulesDetails() {
  yield takeEvery(GET_RULES_DETAILS, getRulesDetails);
}

function* getRulesDetailsSaga() {
  yield all([fork(watchgetRulesDetails)]);
}

export default getRulesDetailsSaga;
